import { Vue } from 'vue-class-component';
import store from '/@/store/store';
import ImgLoader from '/@/assets/img/loader/rings.svg';
import { ConfigModule } from '/@/store/enums';

export default class Loader extends Vue {
	ImgLoader = ImgLoader;

	get loading() {
		return store.get(
			ConfigModule.GET_LOADING,
		);
	}
}
